const DECIMAL_PLACES = 2;

const toFixedNumber = value => {
    return Number.parseFloat(value || 0).toFixed(DECIMAL_PLACES) || '';
};

export {
    toFixedNumber
};
